import * as types from "./constants";

const initialState = {
  loading: true,
  mainImage: null,
  changedImage: null,
  error: null,
};

const reducer = (state = initialState, actions) => {
  switch (actions.type) {
    case types.INITIAL_IMAGE_DATA:
      return {
        ...state,
        mainImage: actions.image,
        loading: actions.loading,
      };

    case types.SAVE_IMAGE_DATA:
      return {
        ...state,
        changedImage: actions.image,
        loading: actions.loading,
      };

    default:
      return state;
  }
};

export default reducer;
